<template>
	<div>
		<v-form ref="form">
			<costs-main-title :number-of-modules="numberOfModules" :module-number="moduleNumber"/>

			<costs-headers/>

			<administrative-empty
				:readonly="readonly"
				:add-administrative="addAdministrative"
				:delete-administrative="deleteAdministrative"
				:move-administrative-up="moveAdministrativeUp"
				:move-administrative-down="moveAdministrativeDown"
				:administrative="administrative"
				:administrative-total="administrativeTotal"
				:options="options"
				:sync="sync"
				:add-cost-division="addAdministrativeCostDivision"
				:delete-cost-division="deleteAdministrativeCostDivision"
				:update-calculated="updateCalculated"
			/> 

			<sum-of-administrative
				:total-administrative="totalAdministrative"
			/>

			<actions-costs-empty
				:readonly="readonly"
				:actions="actions"
				:add-cost="addCost"
				:add-cost-division="addCostDivision"
				:delete-cost-division="deleteCostDivision"
				:move-administrative-up="moveCostUp"
				:move-administrative-down="moveCostDown"
				:costs-key-value="costsKeyValue.toString()"
				:delete-cost="deleteCost"
				:options="options"
				:sync="sync"
				:update-calculated="updateCalculated"
				:actions-total="actionsTotal"
				:costs-total="costsTotal"
				:taken-serial-numbers="takenSerialNumbers"
			/>

			<sum-of-actions
				:total-actions="totalActions"
			/>

			<costs-limits-summary
                :administrative="relativeAdministrativeCosts"
				:administrative-title="relativeAdministrativeCostsTitle"
				:contribution="relativeContribution"
				:contribution-title="relativeContributionTitle"
                
			/>

			<sum-of-all
				:total-actions="totalActions"
				:total-administrative="totalAdministrative"
			/>
			<egranty-validation-error
				:error="error"
			></egranty-validation-error>
		</v-form>
	</div>
</template>

<script>
import SumOfAdministrative from "@/view/logged/offer/components/CostsTableComponents/SumOfAdministrative";
import SumOfAll from "@/view/logged/offer/components/CostsTableComponents/SumOfAll";
import SumOfActions from "@/view/logged/offer/components/CostsTableComponents/SumOfActions";
import AdministrativeEmpty from "@/view/landing_page/components/AdministrativeEmpty";
import CostsMainTitle from "@/view/logged/offer/components/CostsTableComponents/CostsMainTitle";
import CostsHeaders from "@/view/logged/offer/components/CostsTableComponents/CostsHeaders";
import ActionsCostsEmpty from "@/view/landing_page/components/ActionsCostsEmpty";
import EgrantyValidationError from "../../../genericComponents/EgrantyValidationError";
import {Numbers} from "@/utils/Numbers";
import CostsLimitsSummary from "@/view/logged/offer/components/CostsTableComponents/CostsLimitsSummary";

export default {
  name: "CostsTableEmpty",

  components: {
    CostsLimitsSummary,
    EgrantyValidationError,
    ActionsCostsEmpty,
    CostsHeaders,
    CostsMainTitle,
    AdministrativeEmpty,
    SumOfActions,
    SumOfAll, SumOfAdministrative,
  },

  computed: {
    totalCosts () {
      let totalAdministrative = 0;
      let totalActions = 0;

      for (let action of this.actions) {
        for (let actionCost of action.costs) {
          let costValue = actionCost.pricePerUnit * actionCost.unitsCount;
          totalActions += isNaN(costValue) ? 0 : costValue;
        }
      }

      for (let administrativeCost of this.administrative) {
        let costValue = administrativeCost.pricePerUnit * administrativeCost.unitsCount;
        totalAdministrative += isNaN(costValue) ? 0 : costValue;
      }

      return (totalActions + totalAdministrative).toFixed(2);
    },

    relativeAdministrativeCosts () {
        return "";
    },

    relativeAdministrativeCostsTitle () {
        return "Koszty administracyjne w odniesieniu do całości kosztów";
    },

    relativeContributionTitle () {
        return "Wkład własny w odniesieniu do całości kosztów";
    },

    relativeContribution () {
      return "";
    },

    financialContribution () {
      let part1 = parseFloat(this.costsSummary.ownFinancialContribution);
      let part2 = parseFloat(this.costsSummary.moneyFromRecipients);
      let part3 = parseFloat(this.costsSummary.otherPublicSource);
      let part4 = parseFloat(this.costsSummary.other);
      return ((isNaN(part1) ? 0 : part1) +
          (isNaN(part2) ? 0 : part2) +
          (isNaN(part3) ? 0 : part3) +
          (isNaN(part4) ? 0 : part4)).toFixed(2);
    },

    ownContribution () {
      let part1 = parseFloat(this.costsSummary.ownHumanContribution);
      let part2 = parseFloat(this.costsSummary.ownContributionInKind);
      return ((isNaN(part1) ? 0 : part1) +
          (isNaN(part2) ? 0 : part2)).toFixed(2);
    },

    totalContribution () {
      let part1 = parseFloat(this.ownContribution);
      let part2 = parseFloat(this.financialContribution);
      return ((isNaN(part1) ? 0 : part1) +
          (isNaN(part2) ? 0 : part2)).toFixed(2);

    },
  },

  methods: {
    sync () {
      this.reassignSerialNumbers();
      this.error = "";
      for (let action of this.actions) {
        for (let cost of action.costs) {
          this.$set(cost, "errors", []);
        }
      }
      for (let cost of this.administrative) {
        this.$set(cost, "errors", []);
      }
      this.updateCalculated();
    },

    emptyCost () {
      return {
        name: "",
        costDivisions: [
          {
            type: "z dotacji",
            totalPrice: null,
          },
        ],
        pricePerUnit: "",
        measureType: "",
      };
    },

    reassignSerialNumbers () {
      if (this.readonly) return;

      for (let action of this.actions) {

        for (let cost of action.costs) {
          if (!this.isCostSerialNumberPermanentlyTaken(action, cost.serialNumber)) {
            cost.serialNumber = null;
          }
        }

        for (let cost of action.costs) {
          if (!this.isCostSerialNumberPermanentlyTaken(action, cost.serialNumber)) {
            cost.serialNumber = this.getSerialNumber(action);
          }
        }

        action.costs = action.costs.sort((a, b) => a.serialNumber - b.serialNumber);
      }

      for (let cost of this.administrative) {
        if (!this.isAdministrativeSerialNumberPermanentlyTaken(cost.serialNumber)) {
          cost.serialNumber = null;
        }
      }

      for (let cost of this.administrative) {
        if (!this.isAdministrativeSerialNumberPermanentlyTaken(cost.serialNumber)) {
          cost.serialNumber = this.getAdministrativeSerialNumber();
        }
      }

      this.administrative = this.administrative.sort((a, b) => a.serialNumber - b.serialNumber);
    },

    isCostSerialNumberPermanentlyTaken (action, serialNumber) {
        return false;
    },

    getSerialNumber (action) {
      let freeNumber = 0;
      let failed;
      do {
        failed = false;
        freeNumber++;
        for (let actionCost of action.costs) {
          if (actionCost.serialNumber === freeNumber) {
            failed = true;
          }
        }
        if (this.isCostSerialNumberPermanentlyTaken(action, freeNumber)) {
          failed = true;
        }
      } while (failed);
      return freeNumber;
    },


    isAdministrativeSerialNumberPermanentlyTaken (serialNumber) {
        return false;
    },

    getAdministrativeSerialNumber () {
      let freeNumber = 0;
      let failed;
      do {
        failed = false;
        freeNumber++;
        for (let cost of this.administrative) {
          if (cost.serialNumber === freeNumber) {
            failed = true;
          }
        }
        if (this.isAdministrativeSerialNumberPermanentlyTaken(freeNumber)) {
          failed = true;
        }
      } while (failed);
      return freeNumber;
    },

    addAdministrative () {
      let toAdd = this.emptyCost();
      toAdd.serialNumber = this.getAdministrativeSerialNumber();
      this.administrative.push(toAdd);
      this.updateCalculated();
      this.sync();
    },

    addCost (action) {
      let toAdd = this.emptyCost();
      toAdd.serialNumber = this.getSerialNumber(action);
      action.costs.push(toAdd);
      this.updateCalculated();
      this.updateCostsKey();
      this.sync();
    },

    deleteCostDivision (actionCost, divisionIndex) {
      actionCost.costDivisions.splice(divisionIndex, 1);
      this.updateCalculated();
      this.updateCostsKey();
    },

    addCostDivision (actionCost) {
      actionCost.costDivisions.push({
        type: null,
        totalPrice: null,
      });
      this.updateCostsKey();
    },

    addAdministrativeCostDivision (cost) {
      cost.costDivisions.push({
        type: null,
        totalPrice: null,
      });
    },

    deleteAdministrativeCostDivision (cost, divisionIndex) {
      cost.costDivisions.splice(divisionIndex, 1);
      this.updateCalculated();
    },

    deleteCost (action, index) {
      action.costs.splice(index, 1);
      this.updateCalculated();
      this.updateCostsKey();
      this.sync();
    },

    moveCostUp(action, index) {
      if (index === 0) return;
      let tmp = action.costs[index];
      action.costs[index] = action.costs[index - 1];
      action.costs[index - 1] = tmp;
      this.reassignSerialNumbers();
      this.updateCalculated();
      this.updateCostsSummary();
      this.updateCostsKey();
      this.sync();
    },

    moveCostDown(action, index) {
      if (index === action.costs.length - 1) return;
      let tmp = action.costs[index];
      action.costs[index] = action.costs[index + 1];
      action.costs[index + 1] = tmp;
      this.reassignSerialNumbers();
      this.updateCalculated();
      this.updateCostsSummary();
      this.updateCostsKey();
      this.sync();
    },

    updateCostsKey () {
      this.costsKeyValue++;
    },

    deleteAdministrative (index) {
      this.administrative.splice(index, 1);
      this.updateCalculated();
      this.sync();
    },

    moveAdministrativeUp (index) {
      if (index === 0) return;
      let tmp = this.administrative[index];
      this.administrative[index] = this.administrative[index - 1];
      this.administrative[index - 1] = tmp;
      let serialTmp = this.administrative[index].serialNumber;
      this.administrative[index].serialNumber = this.administrative[index - 1].serialNumber;
      this.administrative[index - 1].serialNumber = serialTmp;
      this.sync();
    },

    moveAdministrativeDown (index) {
      if (index === this.administrative.length - 1) return;
      let tmp = this.administrative[index];
      this.administrative[index] = this.administrative[index + 1];
      this.administrative[index + 1] = tmp;
      let serialTmp = this.administrative[index].serialNumber;
      this.administrative[index].serialNumber = this.administrative[index + 1].serialNumber;
      this.administrative[index + 1].serialNumber = serialTmp;
      this.sync();
    },

    updateCalculated () {
      this.totalAdministrative = 0;
      this.totalActions = 0;
      this.costsTotal = [];
      this.administrativeTotal = [];

      for (let i = 0; i < this.actions.length; i++) {
        if (this.costsTotal[i] === undefined) {
          this.$set(this.costsTotal, i, []);
        }
        let total = 0;
        for (let q = 0; q < this.actions[i].costs.length; q++) {
          if (this.actions[i].costs[q].pricePerUnit && this.actions[i].costs[q].unitsCount) {
            this.$set(this.costsTotal[i], q, this.actions[i].costs[q].pricePerUnit * this.actions[i].costs[q].unitsCount);
          } else {
            this.$set(this.costsTotal[i], q, 0);
          }
          if (isNaN(this.costsTotal[i][q])) {
            this.$set(this.costsTotal[i], q, 0);
          }
          total += this.costsTotal[i][q];
          this.actions[i].costs[q].costDivisions[0].totalPrice = 0;
          let given = this.actions[i].costs[q].costDivisions.reduce((sum, current) => ((isNaN(parseFloat(current.totalPrice)) ? 0 : parseFloat(current.totalPrice)) + sum), 0);
          this.actions[i].costs[q].costDivisions[0].totalPrice = Math.max(0, this.costsTotal[i][q] - given);
        }
        this.$set(this.actionsTotal, i, total);
        this.totalActions += total;
      }

      for (let i = 0; i < this.administrative.length; i++) {
        if (this.administrative[i].pricePerUnit && this.administrative[i].unitsCount) {
          this.$set(this.administrativeTotal, i, this.administrative[i].pricePerUnit * this.administrative[i].unitsCount);
        } else {
          this.administrativeTotal[i] = 0;
        }
        if (isNaN(this.administrativeTotal[i])) {
          this.administrativeTotal[i] = 0;
        }
        this.totalAdministrative += this.administrativeTotal[i];
        this.administrative[i].costDivisions[0].totalPrice = 0;
        let given = this.administrative[i].costDivisions.reduce((sum, current) => ((isNaN(parseFloat(current.totalPrice)) ? 0 : parseFloat(current.totalPrice)) + sum), 0);
        this.administrative[i].costDivisions[0].totalPrice = Math.max(0, this.administrativeTotal[i] - given);
      }

      this.keyValue++;
    },

    validateCost (cost) {
      this.$set(cost, "errors", []);

      if (cost.costDivisions.find(x => !x.type)) {
        cost.errors.push("Proszę uzupełnić źródła finansowania");
      }

      if (cost.costDivisions.length !== 1) {
        if (cost.costDivisions.find(x => !x.totalPrice && x.totalPrice !== 0)) {
          cost.errors.push("Proszę uzupełnić kwoty podziału kosztów źródła finansowania");
        } else {

          let expected = cost.pricePerUnit * cost.unitsCount;
          let given = cost.costDivisions.reduce((sum, current) => parseFloat(current.totalPrice) + sum, 0);
          if (Math.abs(given - expected) > 0.001) {
            cost.errors.push("Łączna suma kosztów nie jest równa iloczynowi liczby sztuk i ceny jednostkowej (powinno być " + Numbers.methods.formatMoney(expected) + ", a jest " + Numbers.methods.formatMoney(given) + ")");
          }
        }
      }
    },

    hasDotationCost (cost) {
      return cost.costDivisions.find(x => x.type === "z dotacji") !== undefined;
    },

    validate () {
      let errors = false;
      if (!this.$refs.form.validate()) {
        errors = true;
      }

      let anyDotationCost = false;

      for (let action of this.actions) {
        for (let cost of action.costs) {
          this.validateCost(cost);
          anyDotationCost |= this.hasDotationCost(cost);
          errors |= cost.errors.length !== 0;
        }
      }

      for (let cost of this.administrative) {
        this.validateCost(cost);
        anyDotationCost |= this.hasDotationCost(cost);
        errors |= cost.errors.length !== 0;
      }

      if (anyDotationCost !== 1) {
        this.error = "Proszę dodać co najmniej jeden koszt ze źródłem finansowania rodzaju dotacja";
        errors = true;
      }

      return !errors;
    },

    updateCostsSummary () {
      let res = {
        dotation: 0,
        administrative: 0,
        ownFinancialContribution: 0,
        ownContributionInKind: 0,
        ownHumanContribution: 0,
        moneyFromRecipients: 0,
        other: 0,
        otherPublicSource: 0,
      };

      for (let action of this.actions) {
        for (let cost of action.costs) {
          if (cost.costDivisions.length === 1) {
            this.processCost(res,
                {
                  totalPrice: parseFloat(cost.pricePerUnit) * parseFloat(cost.unitsCount),
                  type: cost.costDivisions[0].type,
                });
          } else {
            for (let division of cost.costDivisions) {
              this.processCost(res, division);
            }
          }
        }
      }

      for (let cost of this.administrative) {
        if (cost.costDivisions.length === 1) {
          this.processCost(res,
              {
                totalPrice: parseFloat(cost.pricePerUnit) * parseFloat(cost.unitsCount),
                type: cost.costDivisions[0].type,
              });
        } else {
          for (let division of cost.costDivisions) {
            this.processCost(res, division);
          }
        }
        res.administrative += parseFloat(cost.pricePerUnit) * parseFloat(cost.unitsCount);
      }

      for (let prop in res) {
        res[prop] = res[prop].toFixed(2);
      }
      this.costsSummary = res;
    },

    processCost (res, costDivision) {
      if (costDivision.type === undefined) {
        return;
      }
      if (costDivision.type === "z dotacji") {
        res.dotation += this.calculateCostTotal(costDivision);
      }
      if (costDivision.type === "środki finansowe własne") {
        res.ownFinancialContribution += this.calculateCostTotal(costDivision);
      }
      if (costDivision.type === "wkład osobowy") {
        res.ownHumanContribution += this.calculateCostTotal(costDivision);
      }
      if (costDivision.type === "wkład rzeczowy") {
        res.ownContributionInKind += this.calculateCostTotal(costDivision);
      }
      if (costDivision.type === "świadczenie pieniężne od odbiorców") {
        res.moneyFromRecipients += this.calculateCostTotal(costDivision);
      }
      if (costDivision.type === "pozostałe") {
        res.other += this.calculateCostTotal(costDivision);
      }
      if (costDivision.type === "środki finansowe z innych źródeł publicznych") {
        res.otherPublicSource += this.calculateCostTotal(costDivision);
      }
    },

    calculateCostTotal (costDivision) {
      let res = parseFloat(costDivision.totalPrice);
      return isNaN(res) ? 0 : res;
    },
  },

  data () {
    return {
      error: "",
      administrative: [],
      actionsTotal: [],
      administrativeTotal: [],
      costsTotal: [],
      actions: [
                {
                    "id": 0,
                    "serialNumber": 1,
                    "action": "",
                    "place": "",
                    "targetGroup": "",
                    "beneficiariesData": {
                        "selected": [],
                        "otherBeneficiary": ""
                    },
                    "realizationDates": [
                        {
                            "start": "2024-07-03",
                            "end": "2024-07-04"
                        }
                    ],
                    "costs": []
                }
            ],
      actionsLoaded: false,
      totalAdministrative: 0,
      totalActions: 0,
      options: [
        "środki finansowe własne",
        "wkład osobowy",
        "wkład rzeczowy",
        "świadczenie pieniężne od odbiorców",
        "pozostałe",
        "środki finansowe z innych źródeł publicznych",
      ],
      keyValue: 0,
      costsKeyValue: 0,
      costsSummary: null,
    };

  },


  props: {
    takenSerialNumbers: {},
    readonly: {
      default: false,
    },
    actionsData: [
                {
                    "id": 0,
                    "serialNumber": 1,
                    "action": "",
                    "place": "",
                    "targetGroup": "",
                    "beneficiariesData": {
                        "selected": [],
                        "otherBeneficiary": ""
                    },
                    "realizationDates": [
                        {
                            "start": "2024-07-03",
                            "end": "2024-07-04"
                        }
                    ],
                    "costs": []
                }
            ],
            
    administrativeCosts: [
                {
                    "serialNumber": 1,
                    "name": "",
                    "costDivisions": [
                        {
                            "type": "z dotacji",
                            "totalPrice": 0.00
                        }
                    ],
                    "unitsCount": 0.00,
                    "pricePerUnit": 0.00,
                    "measureType": ""
                }
            ],
    offerConfiguration: {},
    numberOfModules: {
      default: 0
    },
    moduleNumber: {
      default: ''
    },
  },
};
</script>